import { Typography, Card, CardContent, Box, Link, Button } from '@mui/material';
import { ArrowForwardIos } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import { useGetJobseekerApplicationsRecentQuery } from '@carcareers/store';
import { CardLoader } from '@carcareers/components';
import { Application } from '@libs/models';
import { routes } from '@carcareers/utils';

export const ApplicationsCard = () => {
  const navigate = useNavigate();
  const { data: applications, isLoading } = useGetJobseekerApplicationsRecentQuery();

  return (
    <Card elevation={0} sx={{ borderRadius: 4, border: '1px solid', borderColor: 'divider' }}>
      <CardContent sx={{ p: '16px !important' }}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Recent Applications
        </Typography>
        {isLoading ? (
          <CardLoader />
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {applications?.meta.totalItems === 0 ? (
              <Button variant="contained" color="warning" onClick={() => navigate(`/${routes.JOBSEEKERS}`)}>
                Find A New Career!
              </Button>
            ) : (
              applications?.items.map((application: Application) => (
                <Link
                  key={`application-${application.id}`}
                  href={`/${routes.JOBSEEKERS}/${application.post?.id}`}
                  sx={{
                    textDecoration: 'none',
                    color: 'inherit',
                    display: 'block',
                    py: 1,
                    px: 2,
                    borderRadius: 4,
                    '&:hover': {
                      backgroundColor: 'action.hover',
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                  >
                    <Box>
                      <Typography variant="subtitle2" sx={{ fontWeight: 'medium' }}>
                        {application.post?.job?.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Applied {application.appliedAt ? new Date(application.appliedAt).toLocaleDateString() : 'never'}
                      </Typography>
                    </Box>
                    <ArrowForwardIos sx={{ fontSize: 16, color: 'text.secondary' }} />
                  </Box>
                </Link>
              ))
            )}
            {(applications?.meta?.totalItems && applications?.meta?.totalItems > 3) ? (
              <Button
                size="small"
                color="primary"
                onClick={() => navigate(`/${routes.JOBSEEKER_HOME}/${routes.JOBSEEKER_APPLICATIONS}`)}
                sx={{
                  borderRadius: 4,
                }}
              >
                View All Applications
              </Button>
            ) : null}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
